import React from "react";
import HeroTop from "../components/marketing/pageSections/HeroTop";
import LastProducts from "../components/marketing/pageSections/LastProducts";
import Products from "../components/marketing/pageSections/Products";
import Events from "../components/marketing/pageSections/Events";
import Booking from "../components/marketing/pageSections/Booking";
import Footer from "../components/marketing/pageSections/Footer";

export default function HomePage() {
   return (
      <>
         <HeroTop/>
         <LastProducts />
         <Products/>
         <Events/>
         <Booking />
         <Footer/>
      </>
   );
}
